export default __webpack_public_path__ + "static/media/apply_06_active.d5e7e85d.png";